import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import TextField from "@mui/material/TextField";

import Grid from "@mui/material/Grid";
import Autocomplete, {
  createFilterOptions,
} from "@mui/material/Autocomplete";

import validateEmail from "../../utilities/validateEmail";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import "./style.css";


import reSendOtpResponse from "../../apis/otp/reSendOtp";
import otpVerificationResponse from "../../apis/otpVerification/otpVerfication";
import emailVerificationResponse from "../../apis/otp/emailVerification";
import subSkillBySkillIdResponse from "../../apis/skills/SubSkillBySkillId";
import phoneNumberExistResponse from "../../apis/users/getUserDataByPhoneNumber";
import "./registerTaketest.css";
import "react-phone-number-input/style.css";
import PhoneInput, { isPossiblePhoneNumber, parsePhoneNumber } from "react-phone-number-input";

import { NotificationManager } from "react-notifications";
import getAllPublicTest from "../../apis/Tests/getAllPublicTest";

import fetchCountryStateCity from "../../apis/fetchCountryStateCity";
import Footer from "../adminFooter/Footer";
import Header from "../../pages/home/homeHeader/Header/Header";
const filterSkillOptions = createFilterOptions({
  matchFrom: "start",
  stringify: (option) => option.testName,
});

export default function FormOne() {

  const history = useNavigate();
  const [publictest, setpublictest] = useState([]);
  const hasCalledApi = useRef(false);

  const [userInformation, setUserInformation] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    countryCode: "",
    defaultCountryCode: "",
    locationCountry: {},
    locationState: {},
    locationCity: {},
    selectedSkill: {},
    userOtp: "",
    isCorrectEmailaddress: true,
    isOtpSent: false,
    isOtpVerifying: false,
    isEmailDisabled: false,
    isEmailVerified: false,
    isOtpGettingSent: false,
    isResendingOtp: false,
    sendOtpId: false,
    isValidPhoneNumber: false,
    skillData: {},
    isApiRunning: false,
    isContinueLoading: false,
    isOtpVerified: false,
    isTermsAccepted: false,
  })
  const [locationList, setLocationList] = useState({
    countryList: [],
    stateList: [],
    cityList: [],
    isCountryFetching: false,
    isStateFetching: false,
    isCityFetching: false,
  });
  const [resendButtonTimer, setResendButtonTimer] = useState({
    isActive: false,
    counter: 300000,
  });

  const emailChangeHandler = (event) => {
    const emailValue = event.target.value;
    let isValidEmail = true;
    if (emailValue) {
      isValidEmail = validateEmail(emailValue);
    }
    setUserInformation({
      ...userInformation,
      email: emailValue,
      isCorrectEmailaddress: isValidEmail,
    })
  };
  const changeEmailId = () => {
    setUserInformation({
      ...userInformation,
      isOtpSent: false,
      isOtpVerified: false,
      email: "",
      userOtp: "",
      sendOtpId: false,
    })

    setResendButtonTimer({
      isActive: false,
      counter: 300000,
    })
  };
  const millisToMinutesAndSeconds = (millis) => {
    let minutes = Math.floor(millis / 60000);
    let seconds = ((millis % 60000) / 1000).toFixed(0);
    return (
      minutes +
      ":" +
      (seconds < 10 ? "0" : "") +
      (seconds === 0 ? "00" : seconds)
    );
  };

  useEffect(() => {
    let intervalId;

    if (resendButtonTimer.isActive) {
      intervalId = setInterval(() => {
        if (resendButtonTimer.counter > 0) {
          setResendButtonTimer((prev) => ({ ...prev, counter: prev.counter - 1000 }));
        }
      }, 1000);
    }

    return () => clearInterval(intervalId); ///componentWillUnmount here mounting phase is distroyed
  }, [resendButtonTimer]);

  const reSendOtp = async () => {
    const payloadData = {
      id: userInformation.sendOtpId,
      email: userInformation.email,
      isVerified: false,
    };

    setUserInformation({
      ...userInformation,
      isResendingOtp: true
    });

    try {
      await reSendOtpResponse(payloadData);
      setUserInformation({
        ...userInformation,
        isResendingOtp: false
      });
      setResendButtonTimer({
        isActive: true,
        counter: 300000,
      });
      NotificationManager.success("OTP resent successfully", "Success", 10000);
    } catch (error) {
      console.log(error);
      setUserInformation({
        ...userInformation,
        isResendingOtp: false
      });
      NotificationManager.error("Failed to resend OTP. Please try again.", "Error", 10000);
    }
  };

  const sendOtp = async (e) => {
    const payLoad = {
      email: userInformation.email,
      isVerified: false,
    };

    setUserInformation({
      ...userInformation,
      isOtpGettingSent: true
    });

    try {
      const sendOtpData = await emailVerificationResponse(payLoad);

      if (sendOtpData.status === 200) {
        setUserInformation({
          ...userInformation,
          isOtpGettingSent: false
        });
        return NotificationManager.error(
          "User already exists in ClearedTalent",
          "Error",
          10000
        );
      }
      setUserInformation({
        ...userInformation,
        sendOtpId: sendOtpData.data.id,
        isOtpSent: true,
        isOtpGettingSent: false
      })
      setResendButtonTimer({ ...resendButtonTimer, isActive: true, counter: 300000 });
      NotificationManager.success("OTP sent", "Success", 10000);
    } catch (error) {
      console.log(error.response.data);
      setUserInformation({
        ...userInformation,
        isOtpGettingSent: false
      });
    }
  };
  const otpVerification = async () => {
    const payLoad = {
      id: userInformation.sendOtpId,
      email: userInformation.email,
      otpHash: userInformation.userOtp,
    };
    if (userInformation.userOtp !== "" && userInformation.userOtp.length === 6) {
      setUserInformation({ ...userInformation, isOtpVerifying: true });

      try {
        const verifyOtpData = await otpVerificationResponse(payLoad);
        if (verifyOtpData.data.message.includes("Invalid OTP")) {
          setUserInformation({ ...userInformation, isOtpVerifying: false });
          return NotificationManager.error(
            "Please enter valid OTP",
            "Error",
            10000
          );
        } else {
          setUserInformation({
            ...userInformation,
            isOtpVerified: true,
            isOtpVerifying: false
          });
          return NotificationManager.success("OTP verified", "Success", 10000);
        }
      } catch (error) {
        console.log(error);
        setUserInformation({ ...userInformation, isOtpVerifying: false });
        NotificationManager.error("Failed to verify OTP. Please try again.", "Error", 10000);
      }
    } else {
      NotificationManager.error("Please enter valid OTP", "Error", 10000);
    }
  };

  const getAllpublictests = async () => {
    try {
      let allSkillResponse = await getAllPublicTest();
      setpublictest(allSkillResponse.filter((i) => !i.isPrivate));

    } catch (error) {
      console.log(error.response.data);
    }
  };

  const skillChange = async (event, value) => {
    setUserInformation({
      ...userInformation,
      selectedSkill: value,
    })
  };

  useEffect(() => {
    if (!hasCalledApi.current) {
      hasCalledApi.current = true;
      getAllpublictests();
    }
  }, []);

  const checkPhoneNumber = async (phoneNumber) => {
    var phoneNumberInput = {
      phoneNumber: phoneNumber,
    };
    try {
      const phoneNochkResponse = await phoneNumberExistResponse(
        phoneNumberInput
      );
      if (phoneNochkResponse.data.data[0].isUnique === true) {
        return phoneNochkResponse.data.data[0].isUnique;
      }
    } catch (error) {
      console.log("phonenoresponse", error);
    }
  };
  const continueRegisterHandler = async (e) => {
    e.preventDefault();

    setUserInformation(prev => ({
      ...prev,
      isContinueLoading: true
    }));

    try {
      if (
        !userInformation.firstName ||
        !userInformation.lastName ||
        !userInformation.email ||
        !userInformation.selectedSkill ||
        Object.keys(userInformation.locationCountry).length === 0 ||
        Object.keys(userInformation.locationState).length === 0
      ) {
        setUserInformation(prev => ({
          ...prev,
          isContinueLoading: false
        }));
        return NotificationManager.error(
          "Please fill all required fields",
          "Error",
          10000
        );
      }
      if (!userInformation.isValidPhoneNumber) {
        setUserInformation(prev => ({
          ...prev,
          isContinueLoading: false
        }));
        return NotificationManager.error(
          "Please enter a valid phone number",
          "Error",
          10000
        );
      }
      if (userInformation.phoneNumber !== "") {
        const isunique = await checkPhoneNumber(userInformation.phoneNumber);
        if (!isunique) {
          setUserInformation(prev => ({
            ...prev,
            isContinueLoading: false
          }));
          return NotificationManager.error(
            "Phone number already exists in our system",
            "Error",
            10000
          );
        }
      }
      if (!userInformation.isTermsAccepted) {
        setUserInformation(prev => ({
          ...prev,
          isContinueLoading: false
        }));
        return NotificationManager.error(
          "You must accept the Terms of Use and Privacy Policy to continue.",
          "Error",
          10000
        );
      }
      let subSkillResponse = null
      if (userInformation.selectedSkill.id) {
        subSkillResponse = await subSkillBySkillIdResponse(userInformation.selectedSkill.id);
      }
      else {
        setUserInformation(prev => ({
          ...prev,
          isContinueLoading: false
        }));
        NotificationManager.error("Skill data is not available", "Error", 10000);
        return;
      }

      let pushedState = {
        firstName: userInformation.firstName,
        lastName: userInformation.lastName,
        MiddleInitial: "",
        phoneNumber: userInformation.phoneNumber,
        countryCode: userInformation.countryCode,
        email: userInformation.email,
        locationCountry: JSON.stringify(userInformation.locationCountry),
        locationState: JSON.stringify(userInformation.locationState),
        locationCity: JSON.stringify(userInformation.locationCity),
        skillId: userInformation.selectedSkill.skillId,
        subSkillsJson: subSkillResponse.data.data,
        test: userInformation.selectedSkill,
        pageName: ""

      }
      history("/test-landing", {
        state: pushedState
      });
    } catch (error) {
      console.error("Error in continueRegisterHandler:", error);
      setUserInformation(prev => ({
        ...prev,
        isContinueLoading: false
      }));
      NotificationManager.error("An error occurred. Please try again.", "Error", 10000);
    }
  };



  const countryHandler = (event, value) => {
    if (value) {
      setUserInformation({
        ...userInformation,
        locationCountry: value,
        defaultCountryCode: value.isoCode,
        locationState: {},
        locationCity: {}, 
      });
      setLocationList((prev) => ({
        ...prev,
        stateList: [],
        cityList: [],
      }));
    } else {
      setUserInformation({
        ...userInformation,
        locationCountry: {},
        defaultCountryCode: "",
        locationState: {},
        locationCity: {},
      });
      setLocationList((prev) => ({
        ...prev,
        stateList: [],
        cityList: [],
      }));
    }
  };

  const stateHandler = (event, value) => {
    if (value) {
      setUserInformation({
        ...userInformation,
        locationState: value,
        locationCity: {},
      })
      setLocationList((prev) => ({
        ...prev,
        cityList: []
      }));
    }
    else {
      setUserInformation({
        ...userInformation,
        locationState: {},
        locationCity: {},
      })
      setLocationList((prev) => ({
        ...prev,
        cityList: []
      }));
    }
  };

  const cityHandler = async (event, value) => {
    setUserInformation({
      ...userInformation,
      locationCity: value
    })
  };

  const phoneNumberChangeHandler = (val) => {
    if (val) {
      try {
        const parsedPhone = parsePhoneNumber(val);
        let isValidPhoneNumber = false;

        if (val && isPossiblePhoneNumber(val)) {
          isValidPhoneNumber = true;
        }
        else {
          isValidPhoneNumber = false;
        }

        setUserInformation({
          ...userInformation,
          phoneNumber: parsedPhone?.nationalNumber || val,
          countryCode: parsedPhone?.countryCallingCode ? `+${parsedPhone.countryCallingCode}` : "",
          isValidPhoneNumber: isValidPhoneNumber
        })
      } catch (error) {
        // Handle parsing errors gracefully
        console.log("Phone number parsing error:", error);
        setUserInformation({
          ...userInformation,
          phoneNumber: val,
          countryCode: "",
          isValidPhoneNumber: false
        })
      }
    }
    else {
      setUserInformation({
        ...userInformation,
        phoneNumber: "",
        countryCode: "",
        isValidPhoneNumber: false
      })
    }
  };

  const keypressHandler = (e) => {
    var invalidChars = ["-", "+", "e"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const TermsCheckboxHandler = (e) => {
    setUserInformation({
      ...userInformation,
      isTermsAccepted: e.target.checked,
    })
  };


  const fetchLocationInformation = async (field) => {
    if (field === "country") {
      setLocationList((prev) => ({
        ...prev,
        isCountryFetching: true,
      }));
      try {
        let payload = {
          actionName: "country"
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList({
            ...locationList,
            isCountryFetching: false,
            countryList: response.data.data
          })
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load country list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isCountryFetching: false,
          countryList: [],
        }));
      }
    }
    else if (field === "state") {
      setLocationList((prev) => ({
        ...prev,
        isStateFetching: true,
      }));
      try {

        let payload = {
          actionName: "state",
          countryCode: userInformation.locationCountry.isoCode
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList({
            ...locationList,
            isStateFetching: false,
            stateList: response.data.data
          })
        }

      } catch (error) {
        NotificationManager.error(
          "Unable to load state list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isStateFetching: false,
          stateList: [],
        }));

      }
    }
    else if (field === "city") {
      setLocationList((prev) => ({
        ...prev,
        isCityFetching: true,
      }));
      try {
        let payload = {
          actionName: "city",
          stateCode: userInformation.locationState.isoCode,
        }

        let response = await fetchCountryStateCity(payload)
        if (response.status === 200) {
          setLocationList({
            ...locationList,
            isCityFetching: false,
            cityList: response.data.data
          })
        }
      } catch (error) {
        NotificationManager.error(
          "Unable to load city list. Please try again later.",
          "Error",
          10000
        )
        setLocationList((prev) => ({
          ...prev,
          isCityFetching: false,
          cityList: [],
        }));
      }
    }
  }

  const goToTerms = (e) => {
    window.open("/terms-of-use");
  };

  const goToPrivacyPolicy = () => {
    window.open("/privacy-policy");
  };

  const gotoSignin = () => {
    history("/signIn");
  };

  return (
    <>
      <div className="mainContainer_reg">
        <div className="topContainer">
          <Header isContactOnly={true} />
          <Grid container className="mainDiv_reg">
            <Grid size={{ xs: 12 }}>
              <div className="rightHeading">Register & Take Test</div>
            </Grid>
            <Grid size={{ sm: 6 }}>
              <div className="leftContainer">
                <div className="leftHeading">
                  Please read the instructions below before you start test
                </div>
                <p className="left_points">
                  <span className="leftBullets">1.</span> For multiple choice questions, you may be allowed to pick just one answer choice or multiple. The clock starts as soon as you click <span className="leftBullets">“Start Test”</span> so start <span className="leftBullets">ONLY</span> when you are ready.
                </p>
                <p className="left_points">
                  <span className="leftBullets">2.</span> Some questions may have two parts. For example, Part 1 may be an open ended question where you are expected to speak out your response on video for 1 minute and Part 2 may be a multiple choice question where you are expected to pick the correct answer(s) from the options provided.
                </p>
                <p className="left_points">
                  <span className="leftBullets">3.</span> You will be video recorded during the test so please ensure your camera is active and focusing on you.
                </p>
                <p className="left_points">
                  <span className="leftBullets">4.</span> Please note that at no point during the test you can go back to the previous questions.
                </p>
                <p className="left_points">
                  <span className="leftBullets">5.</span> Please try not to navigate out of the test window (or open other applications) for the test duration. We detect such movements and report them to the reviewer.

                </p>
              </div>
            </Grid>

            <Grid size={{ sm: 6 }} >
              <div className="rightContainer">

                <>
                  <Grid container spacing={1}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputLabel_right">First Name*</div>
                      <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                          placeholder="Enter your first name"
                          className="admin_textbox"
                          onChange={(e) => setUserInformation({ ...userInformation, firstName: e.target.value })}
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputLabel_right">Last Name*</div>
                      <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                          placeholder="Enter your last name"
                          className="admin_textbox"
                          onChange={(e) => setUserInformation({ ...userInformation, lastName: e.target.value })}
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ sm: 12 }}>
                      <div className="inputLabel_right_email">
                        Email (OTP Verification Required)*
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                          placeholder="Enter email"
                          className="admin_textbox"
                          value={userInformation.email}
                          onChange={(event) => emailChangeHandler(event)}
                          disabled={userInformation.isOtpSent && !userInformation.isOtpVerified}
                        />
                      </FormControl>
                      {/* {formError ? (
                        <>
                          {" "}
                          {verifyEmailBtn ? (
                            ""
                          ) : (
                            <p className="form-error fs-regular">
                              Please enter a valid email address
                            </p>
                          )}
                        </>
                      ) : (
                        ""
                      )} */}
                      {!userInformation.isCorrectEmailaddress && (
                        <p className="form-error fs-regular">
                          Please enter a valid email address
                        </p>
                      )}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} >
                      <Grid container spacing={2}>
                        {!userInformation.isOtpSent ? (
                          <>
                            <Grid size={{ xs: 12 }}>
                              <button
                                className={userInformation.isOtpGettingSent ? "sendOtp_disabled" : "sendOtp"}
                                onClick={(e) => sendOtp(e)}
                                disabled={userInformation.isOtpGettingSent || !userInformation.isCorrectEmailaddress || !userInformation.email}
                              >
                                {userInformation.isOtpGettingSent ? (
                                  <>
                                    <CircularProgress size={16} color="inherit" style={{ marginRight: 8 }} />
                                    Sending...
                                  </>
                                ) : (
                                  "Send OTP"
                                )}
                              </button>
                            </Grid>
                          </>
                        ) : (
                          <>
                            <Grid size={{ xs: 12 }}>
                              <div className="resendOtpDiv">
                                {!userInformation.isResendingOtp && (
                                  <button
                                    className="changeEmail"
                                    onClick={(e) => changeEmailId(e)}
                                  >
                                    Change Email
                                  </button>
                                )}

                                {!userInformation.isOtpVerified && (
                                  <button
                                    className={userInformation.isResendingOtp ? "resendOtp_disabled" : "resendOtp"}
                                    onClick={(e) => reSendOtp(e)}
                                    disabled={resendButtonTimer.counter || userInformation.isResendingOtp}
                                  >
                                    {userInformation.isResendingOtp ? (
                                      <>
                                        <CircularProgress size={16} color="inherit" style={{ marginRight: 8 }} />
                                        Resending...
                                      </>
                                    ) : (
                                      "Resend OTP"
                                    )}
                                  </button>
                                )}
                                {!!resendButtonTimer.counter && !userInformation.isOtpVerified && (
                                  <p className="resendotp-timer fs-semi-bold">
                                    {millisToMinutesAndSeconds(resendButtonTimer.counter)}{" "}
                                  </p>
                                )}
                              </div>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Grid>
                    <Grid size={{ sm: 12 }}>
                      <div className="inputLabel_right_email">
                        Enter your OTP*
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                          placeholder="Enter the OTP"
                          className="admin_textbox"
                          value={userInformation.userOtp}
                          onChange={(e) =>
                            setUserInformation({ ...userInformation, userOtp: e.target.value.trim() })
                          }
                          disabled={!userInformation.isOtpSent || userInformation.isOtpVerified}
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      {/* {otpSent && verifyEmailBtn ? ( */}
                      {/* {userInformation.isOtpSent ? (
                        <> */}
                      <button
                        className={userInformation.isOtpVerifying ? "sendOtp_disabled" : "sendOtp"}
                        onClick={(e) => otpVerification(e)}
                        disabled={userInformation.isOtpVerifying || userInformation.isOtpVerified || !userInformation.isOtpSent || !userInformation.userOtp}
                      >
                        {userInformation.isOtpVerifying ? (
                          <>
                            <CircularProgress size={16} color="inherit" style={{ marginRight: 8 }} />
                            Verifying...
                          </>
                        ) : userInformation.isOtpVerified ? (
                          "Verified"
                        ) : (
                          "Verify"
                        )}
                      </button>
                      {/* </> */}
                      {/* ) : (
                        <>
                          <button className="sendOtp_disabled">Verify</button>
                        </>
                      )} */}
                    </Grid>

                  </Grid>

                  <Grid container spacing={1}>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputLabel_right">Country*</div>
                      <Autocomplete
                        id="combo-box-demo"
                        className="mt_14"
                        options={locationList.countryList}
                        autoHighlight
                        // filterOptions={filterOptions}
                        // defaultValue={modalCountryObject}
                        getOptionLabel={(option) => option.name || ""}
                        filterSelectedOptions
                        value={userInformation.locationCountry}
                        onChange={countryHandler}
                        loading={locationList.isCountryFetching}
                        onFocus={() => locationList.countryList.length > 0 ? null : fetchLocationInformation("country")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            required={true}
                            placeholder="Select country"
                            slotProps={{
                              input: {
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {locationList.isCountryFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputLabel_right">Phone Number</div>
                      <div className="select customized-select dropdown_width_recruiter_invite w100 numericContainer">
                        <PhoneInput
                          international
                          defaultCountry={userInformation.defaultCountryCode}
                          country={userInformation.defaultCountryCode}
                          className="textbox_phone_input"
                          placeholder="Enter phone number"
                          value={userInformation.phoneNumber && userInformation.countryCode ?
                            userInformation.countryCode + userInformation.phoneNumber :
                            userInformation.phoneNumber || ""}
                          onChange={(e) => phoneNumberChangeHandler(e)}
                          onKeyPress={(e) => keypressHandler(e)}
                        />
                        {(!userInformation.isValidPhoneNumber && userInformation.phoneNumber) ? (
                          <p className="form-error fs-regular">
                            Please enter a valid phone number
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputLabel_right">State*</div>
                      <Autocomplete
                        id="combo-box-demo"
                        className="mt_14"
                        options={locationList?.stateList}
                        autoHighlight
                        // filterOptions={filterOptions}
                        // value={modalStateObject}
                        getOptionLabel={(option) => option.name || ""}
                        loading={locationList.isStateFetching}
                        filterSelectedOptions
                        value={userInformation.locationState}
                        disabled={Object.keys(userInformation.locationCountry).length === 0}
                        onFocus={() => locationList.stateList.length > 0 ? null : fetchLocationInformation("state")}
                        onChange={stateHandler}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            required={true}
                            placeholder="Select state"
                            slotProps={{
                              input: {
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {locationList.isStateFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      <div className="inputLabel_right">City</div>
                      <Autocomplete
                        id="combo-box-demo"
                        className="mt_14"
                        options={locationList.cityList}
                        autoHighlight
                        // filterOptions={filterOptions}
                        filterSelectedOptions
                        value={userInformation.locationCity}
                        getOptionLabel={(option) => option.name || ""}
                        onFocus={() => locationList.cityList.length > 0 ? null : fetchLocationInformation("city")}
                        disabled={Object.keys(userInformation.locationState).length === 0}
                        loading={locationList.isCityFetching}
                        onChange={cityHandler}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            required={true}
                            placeholder="Select city"
                            slotProps={{
                              input: {
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {locationList.isCityFetching ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              },
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <div className="inputLabel_right">Select Skill*</div>
                      <Autocomplete
                        id="combo-box-demo"
                        className="mt_14"
                        options={publictest}
                        autoHighlight
                        filterOptions={filterSkillOptions}
                        value={userInformation.selectedSkill}
                        getOptionLabel={(option) => option.testName || ""}

                        onChange={skillChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            required
                            placeholder="Select a skill"
                          />
                        )}
                      />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <div className="termsContainer">
                        <div className="video-interview-chkbox basicinfo_chkbox">
                          <input
                            type="checkbox"
                            id="terms"
                            checked={userInformation.isTermsAccepted}
                            onChange={(e) => { }}
                            onClick={(e) => TermsCheckboxHandler(e)}
                          />
                          <label htmlFor="terms"></label>
                        </div>
                        <p className="f-color fs-semi-bold fs-16">
                          {" "}
                          I agree to ClearedTalent’s{" "}
                          <span className="termsLink" onClick={goToTerms}>
                            {" "}
                            Terms of Use{" "}
                          </span>
                          <span className="text-cyan"> & </span>
                          <span
                            className="termsLink"
                            onClick={goToPrivacyPolicy}
                          >
                            Privacy Policy{" "}
                          </span>
                        </p>
                      </div>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                      <div className="continue_container">
                        <button
                          disabled={!userInformation.isOtpVerified || userInformation.isContinueLoading}
                          onClick={(e) => continueRegisterHandler(e)}
                          className={userInformation.isContinueLoading ? "continue_button_disabled" : "continue_button"}
                        >
                          {userInformation.isContinueLoading ? (
                            <>
                              <CircularProgress size={16} color="inherit" style={{ marginRight: 8 }} />
                              Please wait...
                            </>
                          ) : (
                            "Continue"
                          )}
                        </button>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <div className="note">
                      Note : A field marked with * implies mandatory
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <div className="alreadyAccount">
                      Already have an account?{" "}
                      <div className="loginLink" onClick={gotoSignin}>
                        Log-in
                      </div>
                    </div>
                  </Grid>
                </>

              </div>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </div>
    </>
  );
}
